import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgControl} from '@angular/forms';
import * as moment from 'moment';
import {KeyIdentifierModel} from '@service/models';
import {SharedkeyDataService} from '@service/services/common-services/sharedkey-data.service';
import {StateList} from '@service/enum/process-state.enum';

@Directive({
    selector: '[min-max]'
})
export class CustomMinMaxValidatorDirective {
    @Output('min-max') valid = new EventEmitter<void>(); // tslint:disable-line:no-output-rename
    @Input() minValue: number;
    @Input() maxValue: number;

    keyIdentifier: KeyIdentifierModel;
    constructor(private elRef: NgControl,  private sharedKeyDataService: SharedkeyDataService   ) {
        sharedKeyDataService.keyIdentifier$.subscribe((data) => {
            this.keyIdentifier = data;
        });
    }

    @HostListener('focusout')
    handleClick() {
        this.markFieldsAsDirty();
        this.emitIfValid();
    }

    private markFieldsAsDirty() {
        const name: string = (this.elRef.name) ? this.elRef.name.toString() : undefined;
        if (this.elRef.value === undefined || this.elRef.value === null) {
            this.elRef.control.setErrors({'min-max': true});
        } else if (name === 'last4SSN') {
            if (this.elRef.value.toString().length !== 4) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'zipCode' && this.elRef.value.toString().length !== 5) {
            this.elRef.control.setErrors({'min-max': true});
        } else if (name === 'dateOfBirth' || name === 'dob' || name === 'dateOfBirthBeneficiary') {
            const dob = this.elRef.control.value;
            const minAge = (this.minValue || this.minValue === 0) ? this.minValue : 0;
            const maxAge = (this.maxValue || this.maxValue === 0) ? this.maxValue : 85;
            const today = moment().startOf('day');
            const delta = today.diff(dob, 'years', false);
            if (delta < minAge) {
                this.elRef.control.setErrors({'min': true});
            } else if (delta > maxAge) {
                this.elRef.control.setErrors({'max': true});
            }
        } else if (name === 'email') {
            // tslint:disable-next-line:max-line-length
            const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!EMAIL_REGEX.test(this.elRef.control.value)) {
                this.elRef.control.setErrors({'email': true});
            }
        } else if (name === 'payOffAmount' && this.elRef.value !== undefined) {
            if (this.elRef.value < 5000) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'last4SSN' && (this.elRef.value.toString().length !== 4 || isNaN(Number(this.elRef.value.toString())))) {
                this.elRef.control.setErrors({'min-max': true});
        }  else if ((name === 'income' || name === 'deposit_amount' || name.toString().indexOf('amount_') >= 0) && this.elRef.value !== undefined) {
            const minAmount = (this.minValue >= 0) ? this.minValue : 0;
            const maxAmount = (this.maxValue >= 0) ? this.maxValue : 99999;
            console.log('Deposit max and mins are =>', maxAmount, minAmount);
            if (this.elRef.value && Number(this.elRef.value.toString().replace(/[^0-9]*/g, '')) < minAmount) {
                this.elRef.control.setErrors({'min-max': true});
                console.log('Deposit min error');
            }
            if (this.elRef.value && Number(this.elRef.value.toString().replace(/[^0-9]*/g, '')) > maxAmount) {
                this.elRef.control.setErrors({'min-max': true});
                console.log('Deposit max error');
            }
        } else if (name === 'residenceMonths' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
            if (Number(this.elRef.value) > 12) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'residenceYears' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
            if (Number(this.elRef.value) > 50) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'employeeLengthYear' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
            if (Number(this.elRef.value) > 50) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'employeeLengthMonth' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
            if (Number(this.elRef.value) > 12) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'employmentAddYears' && this.elRef.value !== undefined) {
            if (this.elRef.value < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'employmentAddMonths' && this.elRef.value !== undefined) {
            if (this.elRef.value < 0) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'loanAmount' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < 5000) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'percentageOwnership' && this.elRef.value !== undefined) {
            if (Number(this.elRef.value) < this.minValue || Number(this.elRef.value) > this.maxValue) {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else if (name === 'addressState' || name === 'state') {
            const state = this.elRef.value.toString();
            const allStatesCodes = StateList.map(item => item.code);

            if (state && allStatesCodes.indexOf(state.toUpperCase()) === -1)  {
                this.elRef.control.setErrors({'min-max': true});
            }
        } else { // for all other name  value
            const value = this.elRef.value ? this.elRef.value.toString().replace(/[^0-9]*/g, '') : null;
            if ((this.minValue && Number(value) < this.minValue) || (this.maxValue && Number(value) > this.maxValue)) {
                this.elRef.control.setErrors({'min-max': true});
            }
        }
    }

    private emitIfValid() {
        if (this.elRef.valid) {
            this.valid.emit();
        }
    }
}
